import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/backtop.png'


const _withScopeId = n => (_pushScopeId("data-v-eab4c8ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "backtop"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_backtop = _resolveComponent("el-backtop")!

  return (_openBlock(), _createBlock(_component_el_backtop, {
    bottom: 100,
    right: 15
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}